function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Map Icon/Gas/Unexpected (Large)"
}, React.createElement("g", {
  id: "Group 7"
}, React.createElement("g", {
  id: "Group 5 Copy 6"
}, React.createElement("g", {
  id: "Oval 17",
  opacity: 0.8,
  filter: "url(#filter0_f)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.4104 49.7389C29.4899 49.7389 35.229 49.2328 35.229 48.6085C35.229 47.9841 29.4899 47.478 22.4104 47.478C15.3309 47.478 9.5918 47.9841 9.5918 48.6085C9.5918 49.2328 15.3309 49.7389 22.4104 49.7389Z",
  fill: "#072438"
})), React.createElement("g", {
  id: "Group 4"
}, React.createElement("path", {
  id: "Page 1",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0446 0C12.3756 0 4.46484 8.05539 4.46484 17.9693C4.46484 21.8939 5.73434 25.611 7.9808 28.7094L21.2633 47.0911C21.5565 47.5049 22.2397 47.608 22.6309 47.298C22.7285 47.1949 22.7285 47.1949 22.826 47.0911L36.1085 28.7094C38.3549 25.611 39.6244 21.8939 39.6244 17.9693C39.6244 8.05539 31.7137 0 22.0446 0Z",
  fill: "#072438"
})))), React.createElement("path", {
  id: "Oval 16",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0007 30.5502C28.9371 30.5502 34.5601 24.8754 34.5601 17.8752C34.5601 10.875 28.9371 5.2002 22.0007 5.2002C15.0644 5.2002 9.44141 10.875 9.44141 17.8752C9.44141 24.8754 15.0644 30.5502 22.0007 30.5502Z",
  fill: "white"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_f",
  x: 0.893295,
  y: 38.7795,
  width: 43.0342,
  height: 19.6579,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 4.34925,
  result: "effect1_foregroundBlur"
})));

var SvgIconMapmarker = function SvgIconMapmarker(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 44,
    height: 59,
    viewBox: "0 0 44 59",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconMapmarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mapmarker.2231ec5c.svg";
export { ForwardRef as ReactComponent };